import { ConsultantProcessApiConfig } from "@/config/consultant-process-api";
import { RegionConfig } from "@/config/region";

import { AlgoliaConfig } from "./algolia";
import { CaptchaKeyConfig } from "./captcha-key";
import { ConsumerCartServiceConfig } from "./consumer-cart-service";
import { ContentServiceConfig } from "./content.service";
import { GoogleMapsApiConfig } from "./google-maps-api";
import { HybrisConfig } from "./hybris";
import { IdentityServiceConfig } from "./identity-service";
import { PartyProcessApiConfig } from "./party-process-api";
import { PayPalConfig } from "./paypal";
import { PowerReviewsConfig } from "./power-reviews";
import { ProductCatalogApiConfig } from "./product-catalog-api";
import { SOLRConfig } from "./solr";
import { RedisMemoryConfig } from "@/config/redis-memory";
import { RedisPubSubConfig } from "@/config/redis-pub-sub";
import { QuizConfig } from "./quiz";

export { getConfig } from "./config";

export type LoggingLevel = "info" | "debug" | "verbose";

export type PcEnvironment = "sandbox" | "test" | "prod" | "local";

export interface LoggerConfig {
	outputType: "machine" | "human";
	level: LoggingLevel;
	logServiceDisabled: boolean;
	serviceName: string;
	hostName: string;
}

export interface Config {
	pcEnvironment: PcEnvironment;
	appName: string;
	appVersion: string;
	algolia: AlgoliaConfig;
	identityService: IdentityServiceConfig;
	consumerCartService: ConsumerCartServiceConfig;
	contentService: ContentServiceConfig;
	hybris: HybrisConfig;
	logger: LoggerConfig;
	region: RegionConfig;
	productCatalogApi: ProductCatalogApiConfig;
	solr: SOLRConfig;
	partyProcessApi: PartyProcessApiConfig;
	consultantProcessApi: ConsultantProcessApiConfig;
	googleMaps: GoogleMapsApiConfig;
	captcha: CaptchaKeyConfig;
	redisMemoryConfig: RedisMemoryConfig;
	redisPubSubConfig: RedisPubSubConfig;
	quizConfig: QuizConfig;
	powerReviews: PowerReviewsConfig;
	paypal: PayPalConfig;
}
